import {OrderItemModel} from "./order-item.model";

export class OrderModel {
  public venueId: string;
  public venueEmployeeId:	string;
  public capacityTableId:	string;
  public currencyId: string;
  public note:	string;
  public price:	number;
  public priceWithTax: number;
  public items: Array<OrderItemModel>;
  public needValidation: boolean = true;
  public createDate:	string;
}
